<template>
  <div class="header">
    <div class="side _l">
      <!-- back -->
      <div v-if="back" class="back" @click="back">
        <img src="@img/header/back.svg">
      </div>
      <div class="title _left">{{leftTitle}}</div>
    </div>
    <div class="title _center">{{title}}</div>
    <div class="side _r">
      <slot></slot>
      <div v-if="close" class="header-button" @click="close"><img src="@img/header/close.svg"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    leftTitle: String,
    back: Function,
    close: Function,
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(#000000, 4%);
  height: 2.9rem;
  z-index: 2;
  .title {
    @include textEnhance();
    line-height: 1;
    font-size: 90%;
    font-weight: 500;
    &._left {
      position: relative;
      top: -0.1rem;
    }
    &._center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    &._l {
      left: $main_P;
    }
    &._r {
      right: $main_P;
    }
  }
  //
  .header-button {
    @include header-button();
  }
  .back {
    @include header-button();
    & + .title._left {
      margin-left: 0.6rem;
    }
  }
  .nav_btn {
    @include header-button();
    &:not(:last-child) {
      margin-right: 0.8rem;
    }
  }
}
</style>